import { useRef, useLayoutEffect } from "react";

export const Detail = ({
  frontContent,
  backContent,
  color,
  size,
  icon,
  position = "top",
}) => {
  const frontRef = useRef(null);
  const backRef = useRef(null);
  const innerRef = useRef(null);

  useLayoutEffect(() => {
    function updateHeight() {
      if (!frontRef.current || !backRef.current || !innerRef.current) return;
      const frontHeight = frontRef.current.offsetHeight;
      const backHeight = backRef.current.offsetHeight;
      const maxHeight = Math.max(frontHeight, backHeight);

      window.innerWidth < 576 &&
        (innerRef.current.style.height = `${maxHeight}px`);
      backRef.current.style.height = `${maxHeight}px`;
    }

    updateHeight();
    window.addEventListener("resize", updateHeight);
    return () => window.removeEventListener("resize", updateHeight);
  }, []);

  return (
    <div className="flip-card">
      <div
        ref={innerRef}
        className={`flip-card-inner course-details__detail bg-white --${color} --${size} --${position}`}
      >
        <div className="flip-card-front" ref={frontRef}>
          <i className={`las la-${icon} is-400`} />
          {frontContent}
        </div>

        <div className="flip-card-back" ref={backRef}>
          <i className={`las la-${icon} is-400`} />
          {backContent || frontContent}
        </div>
      </div>
    </div>
  );
};
